import React, { Component } from 'react';
import Countdown from 'react-countdown';
import './Breadcrumb.css';
import { eventBus } from '../../utils/tool';

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {
            targetTimestamp: 0
        };
    }

    componentDidMount() {
        // 监听时间戳更新事件
        eventBus.addListener('updateEndTime', this.handleEndTimeUpdate);
    }

    componentWillUnmount() {
        // 移除监听器
        eventBus.removeListener('updateEndTime', this.handleEndTimeUpdate);
    }

    handleEndTimeUpdate = (timestamp) => {
        // 1741489200
        const now = Date.now();
        if (now > 1741575600000) {
            console.log('当前时间戳', now, timestamp, (now - timestamp) / 1000 / 60)

            this.setState({ targetTimestamp: timestamp });
        } else {
            this.setState({ targetTimestamp: 0 });
        }

    }

    render() {
        const renderer = ({ days, hours, minutes, seconds, completed }) => {
            if (completed) {
                // return <span className="countdown-complete">活动已结束！</span>;
                return <span></span>
            }

            return (
                <div className="countdown-container">
                    <div className="countdown-item">
                        <div className="countdown-value">{String(days).padStart(2, '0')}</div>
                        <div className="countdown-label">天</div>
                    </div>
                    <div className="countdown-item">
                        <div className="countdown-value">{String(hours).padStart(2, '0')}</div>
                        <div className="countdown-label">时</div>
                    </div>
                    <div className="countdown-item">
                        <div className="countdown-value">{String(minutes).padStart(2, '0')}</div>
                        <div className="countdown-label">分</div>
                    </div>
                    <div className="countdown-item">
                        <div className="countdown-value">{String(seconds).padStart(2, '0')}</div>
                        <div className="countdown-label">秒</div>
                    </div>
                </div>
            );
        };

        return (
            <section className="breadcrumb-area overlay-dark d-flex align-items-center" style={{
                // 'backgroundImage': 'url(https://token-monitor.s3.amazonaws.com/17403785106712025-02-24%2014.28.26.jpg)',
                'backgroundImage': 'url(https://token-monitor.s3.amazonaws.com/1682575140955WechatIMG34927%20%281%29.png)',
                // 'height': '820px',
                // backgroundAttachment: 'fixed',
                // backgroundPosition: '0px 0px',
                backgroundSize: 'cover',
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* Breamcrumb Content */}
                            <div className="breadcrumb-content text-center">
                                <h2 className="m-0">{this.props.title}</h2>
                                {/* <div style={{ fontWeight: 'bold', color: 'red' }} className="breadcrumb d-flex justify-content-center">

                                </div> */}
                                <div className="countdown-wrapper">
                                    {this.state.targetTimestamp > 0 && (
                                        <Countdown
                                            date={this.state.targetTimestamp}
                                            renderer={renderer}
                                        />
                                    )}
                                </div>
                                {/* 
                                <ul>
                                    <li>①：推广享受10代团队佣金，佣金秒到认购钱包地址</li>
                                    <li>②：直推10人获得TP CEO NFT一张</li>
                                    <li>③：不认购没有推广权限，一个地址只能购买一次</li>

                                </ul> */}
                                {/* <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'flex-start' }}>
                                    <div>①：推广享受10代团队佣金，佣金秒到认购钱包地址</div>
                                    <div>②：直推5人获得TP CEO NFT一张</div>
                                    <div>③：不认购没有推广权限，一个地址只能购买一次</div>
                                </div> */}
                                <ol className="breadcrumb d-flex justify-content-center">
                                    {/* <li className="breadcrumb-item"></li> */}
                                    {/* <li className="breadcrumb-item">一：推广享受10代团队佣金，佣金秒到认购钱包地址</li> */}
                                    {/* <li className="breadcrumb-item">一：推广享受10代团队佣金，佣金秒到认购钱包地址</li> */}
                                    {/* <li className="breadcrumb-item"><a href="#">{this.props.subpage}</a></li> */}
                                    {/* <li className="breadcrumb-item active">{this.props.page}</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Breadcrumb;